import Vue from "vue";

export async function show(id) {
  const response = await Vue.prototype.$http.get(`/simple-fnol/${id}`);

  return response.data.data;
}

export async function indexByLead(leadNumber) {
  const response = await Vue.prototype.$http.get(
    `/simple-fnol/lead-number/${leadNumber}`
  );

  return response.data;
}

export async function store(payload) {
  const response = await Vue.prototype.$http.post(`/simple-fnol`, payload);

  return response.data.data;
}

export async function storeForInsured(payload) {
  const response = await Vue.prototype.$http.post(
    `/simple-fnol/for-insured`,
    payload
  );

  return response.data.data;
}

export async function applyFnolChanges(id) {
  const response = await Vue.prototype.$http.post(
    `/simple-fnol/${id}/apply-changes`
  );

  return response.data;
}

export async function destroy(id) {
  const response = await Vue.prototype.$http.delete(`/simple-fnol/${id}`);

  return response.data;
}

export async function shareViaSms(id, payload) {
  const response = await Vue.prototype.$http.post(
    `/simple-fnol/${id}/share-sms`,
    payload
  );

  return response.data.data;
}

export async function shareViaEmail(id, payload) {
  const response = await Vue.prototype.$http.post(
    `/simple-fnol/${id}/share-email`,
    payload
  );

  return response.data.data;
}
